import type { ReactElement } from 'react';

import { Card, Flex, Skeleton } from '@rango-dev/whale';
import React from 'react';

import styles from './AffiliateFallback.module.css';

const ABOUT_CARDS = [0, 1, 2];

export function AffiliateFallback(): ReactElement {
  return (
    <Card size={{ initial: '2', sm: '5' }} variant="surface">
      <Flex direction="column" align="center" flexGrow="1">
        <Flex direction="column" gap="9" width="100%" maxWidth="1408px">
          <Flex
            direction={{ initial: 'column-reverse', lg: 'row' }}
            align="center"
            justify="between"
            gap="6"
            width="100%">
            <Flex
              direction="column"
              align={{ initial: 'center', lg: 'start' }}
              gap="5"
              flexGrow="1"
              flexBasis="0"
              flexShrink="1"
              width="100%">
              <Flex
                direction="column"
                align={{ initial: 'center', lg: 'start' }}
                gap="3"
                width="100%">
                <Skeleton width={{ initial: '296px', lg: '328px' }} height="80px" />
                <Skeleton width={{ initial: '296px', lg: '478px' }} height="48px" />
              </Flex>
              <Skeleton
                width={{ initial: '296px', lg: '161px' }}
                height={{ initial: '40px', lg: '48px' }}
              />
            </Flex>

            <Flex justify="center" flexShrink="0" width={{ initial: '296px', lg: '372px' }}>
              <Skeleton
                width={{ initial: '296px', lg: '372px' }}
                height={{ initial: '296px', lg: '372px' }}
              />
            </Flex>
          </Flex>

          <Flex
            direction={{ initial: 'column', lg: 'row' }}
            align={{ initial: 'center', lg: 'start' }}
            justify="center"
            gap="5"
            width="100%">
            {ABOUT_CARDS.map((card) => (
              <Card
                key={`affiliate-fallback-card-${card}`}
                size="3"
                variant="surface"
                className={styles.aboutCard}>
                <Flex
                  direction={{ initial: 'row', lg: 'column' }}
                  align="center"
                  gap={{ initial: '3', sm: '5' }}
                  width="100%">
                  <Flex flexShrink="0">
                    <Skeleton
                      width={{ initial: '84px', lg: '160px' }}
                      height={{ initial: '84px', lg: '160px' }}
                    />
                  </Flex>
                  <Flex
                    direction="column"
                    gap={{ initial: '1', sm: '3' }}
                    align={{ initial: 'start', lg: 'center' }}
                    flexGrow="1"
                    minWidth="1px"
                    width="100%">
                    <Skeleton
                      width={{ initial: '122px', lg: '128px' }}
                      height={{ initial: '26px', lg: '30px' }}
                    />
                    <Skeleton width="100%" height={{ initial: '60px', lg: '48px' }} />
                  </Flex>
                </Flex>
              </Card>
            ))}
          </Flex>
        </Flex>
      </Flex>
    </Card>
  );
}
